<!--
 * @Description: 商品列表
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:22:29
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-03 17:01:06
-->
<template>
  <div>
    <!-- 搜索框 -->
    <div style="text-align: left;padding-right: 20px;" class="">
      <el-input class="search-text" placeholder="请输入订单号" v-model="orderId" @keyup.enter.native="getPageSearch">
        <i class="el-icon-search el-input__icon" slot="prefix" style='cursor: pointer' @click.stop="getPageSearch"></i>
      </el-input>
    </div>
    <!-- 主体 -->
    <div style="text-align: left;font-size: 14px;margin-top: 10px;color:#808080" v-if="tableData.length===0" key="1">暂无订单</div>
    <div style="margin-top: 10px;overflow-y: overlay;" v-el-height="{bottomOffset:90}" v-else key="2">
      <div v-for="item in tableData" :key="item.id" class="item_class">
        <div class="flex flex-bet flex-align-center">
          <div class="flex flex-align-center">
            <div style="background-color: #aaa;color: #fff;padding: 4px 10px;border-radius: 8px">{{item.statusStr||'未知'}}</div>
            <div style="margin-left: 10px;cursor: pointer" @click="routerToAfterSales(item)" title="点击跳转查看订单">{{item.orderId}}</div>
          </div>
          <div class="item_baby" @click="sendOrderList(item)">
            发送订单
          </div>
        </div>
        <div class="flex flex-align-center" style="color: #999">
          <div>
            <span>{{$dayjs(item.createTime)}}</span>
            <span>下单</span>
          </div>
          <div v-if="item.paid == 1" class="marL10">
            <span>{{$dayjs(item.createTime)}}</span>
            <span>付款</span>
          </div>
        </div>
        <div style="text-align: left;margin-bottom: 5px;">
          <div v-if="item.paid == 1"><span style="color: #303133">实际支付：</span><span style="color: #f60;font-weight: 600">￥{{item.payPrice}}</span></div>
          <div v-else style="color: #aaa;">未支付</div>
        </div>
        <div v-for="child in item.storeOrderCartInfoDOList" :key="child.id" class="flex child_box">
          <div class="item_image flexShrink0" style="background-color: #eee;border-radius: 10px;overflow: hidden;">
            <el-image style="width: 100%; height: 100%" :src="child.cartInfo.productInfo.attrInfo.image" :preview-src-list="item.picList">
            </el-image>
            <!-- <img :src="child.cartInfo.productInfo.attrInfo.image" alt="" style="width:100%;height: 100%"> -->
          </div>
          <div style="margin-left: 10px;text-align: left;background-color: #eee;padding: 10px;border-radius: 10px;" class="flex1 flex flex-align-center">
            <div>
              <div class="ellipsis" style="width: 260px;color:#66b1ff;cursor: pointer" :title="child.cartInfo.productInfo.storeName" @click="routerToProductDetail(child.cartInfo.productInfo.attrInfo)">
                {{child.cartInfo.productInfo.storeName}}
              </div>
              <div>{{child.cartInfo.productInfo.attrInfo.sku }}</div>
              <div class="flex flex-align-center">
                <div style="color: #ff602d;">{{ '￥' + child.cartInfo.truePrice + ' x ' + child.cartInfo.cartNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页功能 -->
    <Pagination :total="totalRecord" :page.sync="pageNo" :limit.sync="pageSize" @getPageChange="getPageChange" v-if="tableData.length>0" />
  </div>
</template>
  
<script>
import { myEvalFn } from '@/utils/func.js'
export default {
  data() {
    return {
      totalRecord: 0, // 总数
      pageSize: 50, // 每页条数
      pageNo: 1, // 当前页码
      tableData: [],
      orderId: '',
      kmallUserId: ''
    }
  },
  mounted() {
    this.getShopDetail()
  },
  methods: {
    // 跳转到售后
    routerToAfterSales(item) {
      const params = {
        orderId: item.orderId
      }
      const queryString = new URLSearchParams(params).toString()
      const targetUrl = `${process.env.VUE_APP_SHOP_BASE_URL}/#/mall/order/store-order?${queryString}`;
      window.open(targetUrl, '_blank', 'width=1780,height=720,top=50, left=50')
    },

    // 跳转详情
    routerToProductDetail(data) {
      const params = {
        type: data.type,
        id: data.productId
      }
      const queryString = new URLSearchParams(params).toString()
      const targetUrl = `${process.env.VUE_APP_SHOP_BASE_URL}/#/mall/product/form?${queryString}`;
      window.open(targetUrl, '_blank', 'width=1780,height=720,top=50, left=50')
    },

    // 发送订单
    sendOrderList(item) {
      const { picList, cost, createTime, id, orderId, orderType, paid, payPrice, payTime, payType, shippingType, status, statusStr, storeId, storeOrderCartInfoDOList, totalNum, totalPrice, totalPostage, uid, unique, useIntegral } = item
      const storeProductArr = storeOrderCartInfoDOList.reduce((prev, cur) => {
        prev.push({
          orderId: cur.orderId,
          cartId: cur.cartId,
          id: cur.id,
          oid: cur.oid,
          productId: cur.productId,
          unique: cur.unique,
          payPrice: cur.payPrice,
          storeName: cur.cartInfo?.productInfo?.storeName,
          sku: cur.cartInfo?.productInfo?.attrInfo?.sku,
          truePrice: cur.cartInfo?.truePrice,
          cartNum: cur.cartInfo?.cartNum,
          image: cur.cartInfo?.productInfo?.attrInfo?.image
        })
        return prev
      }, [])
      const data = { picList, cost, createTime, id, orderId, orderType, paid, payPrice, payTime, payType, shippingType, status, statusStr, storeId, storeProductArr, totalNum, totalPrice, totalPostage, uid, unique, useIntegral }
      this.$emit('sendRichTextOrder', data)
    },

    // 修改页数
    getPageChange(page) {
      this.pageSize = page.limit
      this.pageNo = page.page
      this.getShopDetail(true)
    },

    getPageSearch() {
      this.pageNo = 1
      this.getShopDetail(true)
    },

    // 获取订单列表
    getShopDetail(isSearch) {
      const queryParams = {
        shippingType: 1,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderId: this.orderId,
        realName: '',
        userPhone: '',
        createTime: [],
        orderStatus: '',
        payStatus: '',
        state: '',
        uid: this.kmallUserId
      }
      if (isSearch) {
        this.$isLoading.show()
      }
      this.$httpShop({
        url: '/order/store-order/page',
        method: 'get',
        params: queryParams
      }).then((res) => {
        this.$isLoading.close()
        res.data.list.forEach((element, index) => {
          element.picList = []
          element.storeOrderCartInfoDOList.forEach((e, n) => {
            res.data.list[index].storeOrderCartInfoDOList[n].cartInfo = myEvalFn('(' + e.cartInfo + ')')
            if (e.cartInfo?.productInfo?.attrInfo?.image) {
              element.picList.push(e?.cartInfo?.productInfo?.attrInfo?.image)
            }
          })
        })
        this.tableData = res.data.list
        this.totalRecord = res.data.total
      })

    }
  }
}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.item_class {
  background-color: #fff;
  margin-bottom: 20px;
  margin-right: 20px;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  .item_image {
    width: 80px;
    height: 80px;
  }
  .item_baby {
    border: 1px solid #3d7fff;
    border-radius: 2px;
    color: #3d7fff;
    cursor: pointer;
    font-size: 12px;
    text-align: center;
    padding: 3px 20px;
  }
}
.child_box + .child_box {
  margin-top: 10px;
}
</style>